export default __webpack_public_path__ + "static/media/montserrat-v15-latin-regular.fa100f9f.ttf";